<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <div>
        <i class="pi pi-wifi title-card-icon"></i>
      </div>
      <div>
        <p class="mb-0 text-3xl title">{{'menu.machines' | transloco}}</p>
        <p>{{'menu.descriptions.machines' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_MACHINES')" [label]="'common.new' | transloco"
                      pButton pRipple class="md:mr-2 p-button-primary mb-2 md:mb-0" routerLink="new"
                      icon="pi pi-plus"></button>
            </div>
            <div class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.exportXls' | transloco"
                (click)="exportVisible = !exportVisible"
                pButton
                class="p-button-secondary md:mr-2"
                icon="pi pi-file-excel"
              ></button>
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
          </div>
        </div>
        <p-table (onLazyLoad)="onPageChange($event)" [(first)]="first" [(rows)]="rows" [lazy]="true" [paginator]="true"
                 [responsive]="true" responsiveLayout="stack" breakpoint="1450px" [rowsPerPageOptions]="[10,25,50]"
                 [totalRecords]="totalMachines" [value]="machines" styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.serialNumber' | transloco}}</th>
              <th scope="col">{{'attribute.model' | transloco}}</th>
              <th scope="col">{{'attribute.localityState' | transloco}}</th>
              <th scope="col">{{'attribute.alias' | transloco}}</th>
              <th scope="col">{{'attribute.squeezedFruits' | transloco}}</th>
              <th scope="col">{{'attribute.state' | transloco}}</th>
              <th scope="col" *ngIf="authGuard.hasPermission('PERMISSION_VIEW_ALARMS')">
                {{'misc.alarms' | transloco}}
              </th>
              <th scope="col">{{'model.organization' | transloco}}</th>
              <th scope="col" *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')">
                {{'attribute.groups' | transloco}}
              </th>
              <th scope="col" *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_MACHINES') && !deleted"
                  class="w-10rem"></th>
            </tr>
          </ng-template>
          <ng-template let-machine pTemplate="body">
            <tr *ngIf="!loadingMachines">
              <td>
                <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}</span>
                <a [routerLink]="[machine.machineUuid, 'details']">{{machine.serial}}</a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.model' | transloco}}</span>
                {{machine.model.modelName}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.localityState' | transloco}}</span>
                <div [ngStyle]="{'max-width': '10rem'}"
                     class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                     pTooltip="{{machine.geocoding.locality[language]}} ({{machine.geocoding.state[language]}}, {{machine.geocoding.country[language]}})"
                     tooltipPosition="top">
                  {{machine.geocoding.locality[language]}} ({{machine.geocoding.state[language]}}
                  , {{machine.geocoding.country[language]}})
                </div>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
                {{machine.alias}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.squeezedFruits' | transloco}}</span>
                <span
                  *ngIf="machine.telemetryData?.totalSqueezedFruits">{{machine.telemetryData?.totalSqueezedFruits | number : '' : this.language}}</span>
                <span *ngIf="!machine.telemetryData?.totalSqueezedFruits">0</span>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.state' | transloco}}</span>
                <p-tag *ngIf="machine.telemetryData && machine.telemetryData.isPoweredOn"
                       value="{{'attribute.on' | transloco}}"
                       class="green-tag state-tag list-tag"></p-tag>
                <p-tag *ngIf="!machine.telemetryData || !machine.telemetryData.isPoweredOn"
                       value="{{'attribute.off' | transloco}}"
                       class="gray-tag state-tag list-tag"></p-tag>
              </td>
              <td *ngIf="authGuard.hasPermission('PERMISSION_VIEW_ALARMS')">
                <span class="p-column-title bold">{{'misc.alarms' | transloco}}</span>
                <div *ngIf="machine.telemetryData?.hasAlarms && machine.telemetryData?.activeAlarms?.length > 0">
                  {{ this.mapProperty(machine.telemetryData.activeAlarms, 'name').join(', ') }}
                </div>
              </td>
              <td>
                <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                <div [ngStyle]="{'max-width': '12rem'}"
                     class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                     pTooltip="{{machine.organization.name}} ({{machine.organization.orgCode}})"
                     tooltipPosition="top">
                  {{machine.organization.name}} ({{machine.organization.orgCode}})
                </div>
              </td>
              <td *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')">
                <span class="p-column-title bold">{{'attribute.groups' | transloco}}</span>
                <div *ngIf="machine.groups?.length > 0" class="flex flex-wrap"
                     [ngStyle]="{'gap': '0.5rem', 'max-width': '30rem'}">
                  <p-tag *ngFor="let group of machine.groups;let i=index" value="{{group.name}}" class="group-tag"
                         [style]="{'background': group.color, 'color': adjustTextColor(group.color)}">
                  </p-tag>
                </div>
              </td>
              <td *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_MACHINES') && !deleted">
                <span class="p-column-title bold"></span>
                <div class="flex justify-content-end">
                  <button [routerLink]="machine.machineUuid + '/edit'" pButton pRipple
                          class="p-button-rounded btn-primary-light mr-2" icon="pi pi-pencil"></button>
                  <button (click)="confirmAndDelete(machine)" pButton pRipple class="p-button-rounded btn-danger-light"
                          icon="pi pi-trash"></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingMachines">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td *ngIf="authGuard.hasPermission('PERMISSION_VIEW_ALARMS')" class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')" class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_MACHINES') && !deleted" class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalMachines == 0" class="flex align-items-center justify-content-between">{{'pagination.empty'
              | transloco}}</div>
            <div *ngIf="totalMachines > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalMachines ? totalMachines : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalMachines}}
              {{(totalMachines > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="alias">{{'attribute.alias' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.alias" [focus]="filtersVisible"
               (keyup.enter)="filtersVisible = false; applyFilters()" appAutoFocus pInputText class="w-full" id="alias"
               type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="serialNumber">{{'attribute.serialNumber' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.serialNumber" (keyup.enter)="filtersVisible = false; applyFilters()"
               pInputText class="w-full" id="serialNumber" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="eui">{{'attribute.eui' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.eui" (keyup.enter)="filtersVisible = false; applyFilters()"
               pInputText class="w-full" id="eui" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="simNumber">{{'attribute.simNumber' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input [(ngModel)]="currentFilters.simNumber" (keyup.enter)="filtersVisible = false; applyFilters()"
               pInputText class="w-full" id="simNumber" type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.state' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.isPoweredOn" [label]="'misc.poweredOnAndOff' | transloco"
                         name="state" [value]=null></p-radioButton>
        </div>
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.isPoweredOn" [label]="'misc.poweredOnOnly' | transloco" name="state"
                         value="true"></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton [(ngModel)]="currentFilters.isPoweredOn" [label]="'misc.poweredOffOnly' | transloco" name="state"
                         value="false"></p-radioButton>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.connection' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.isOn" [label]="'misc.connectedDisconnected' | transloco"
                         name="connection" [value]=null></p-radioButton>
        </div>
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.isOn" [label]="'misc.connectedOnly' | transloco" name="connection"
                         value="true"></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton [(ngModel)]="currentFilters.isOn" [label]="'misc.disconnectedOnly' | transloco" name="connection"
                         value="false"></p-radioButton>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organization">{{'model.organization' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-treeSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
                      [propagateSelectionUp]="false" [propagateSelectionDown]="false" display="chip" appendTo="body"
                      [options]="hierarchy" [metaKeySelection]="false" selectionMode="checkbox" id="organization">
        </p-treeSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organizationCode">{{'model.organizationCode' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
                       [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="organizationCodes"
                       id="organizationCode"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="model">{{'attribute.model' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.machineModelUuids" [placeholder]="'select.generic' | transloco"
                       [filter]="true" filterBy="modelName" display="chip" styleClass="w-full" appendTo="body"
                       [options]="models"
                       id="model" optionLabel="modelName" optionValue="machineModelUuid">
          <ng-template let-model pTemplate="item">
            <div class="flex align-items-center">
              <div style="width:30px;">
                <img [src]="model.image" [alt]="model.modelName" style="max-height: 30px;max-width: 100%;"/>
              </div>
              <p class="mb-0 ml-1 p-0">{{model.modelName}}</p>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="country">{{'attribute.country' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.countries" [placeholder]="'select.generic' | transloco"
                       [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="countries"
                       (onChange)="onCountryChange($event)" id="country" optionLabel="name"
                       optionValue="name"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="state">{{'attribute.province' | transloco}}/{{'attribute.state' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.states" [placeholder]="'select.generic' | transloco" [filter]="true"
                       display="chip" styleClass="w-full" appendTo="body" [options]="filteredStates"
                       [disabled]="isStateDisabled"
                       (onChange)="onStateChange($event)" id="state" optionLabel="name"
                       optionValue="name"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="locality">{{'attribute.locality' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.localities" [placeholder]="'select.generic' | transloco"
                       [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="filteredLocalities"
                       [disabled]="isLocalityDisabled" id="locality" optionLabel="name"
                       optionValue="name"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="communicationType">{{'attribute.communicationType' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-dropdown [(ngModel)]="currentFilters.communicationType" [placeholder]="'select.generic' | transloco"
                    styleClass="w-full" appendTo="body" [options]="communicationTypes" [showClear]="true"
                    [autoDisplayFirst]="false" id="communicationType" optionLabel="label" optionValue="value">
        </p-dropdown>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="range">{{'attribute.lastCommunicationDate' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-calendar [(ngModel)]="rangeDates" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" [yearRange]="availableYearRange" [firstDayOfWeek]="1" styleClass="w-full"
                    appendTo="body" selectionMode="range" dateFormat="dd/mm/yy" id="range" inputId="range"
                    [placeholder]="'select.dateRange' | transloco"></p-calendar>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.deletion' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-1">
          <p-radioButton [(ngModel)]="currentFilters.deleted" [label]="'misc.deletedOnly' | transloco" name="deleted"
                         [value]="true"></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton [(ngModel)]="currentFilters.deleted" [label]="'misc.notDeletedOnly' | transloco" name="deleted"
                         [value]="false"></p-radioButton>
        </div>
      </div>
    </div>
    <div *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')" class="col-12">
      <div class="col-12 form-field">
        <label for="group">{{'attribute.group' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.machineGroupsUuids" [placeholder]="'select.generic' | transloco"
                       [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body"
                       [options]="groups"
                       id="group" optionLabel="name" optionValue="machineGroupUuid">
          <ng-template let-group pTemplate="item">
            <div class="flex align-items-center">
              <p-tag value="{{group.name}}" class="group-tag"
                     [style]="{'background': group.color, 'color': adjustTextColor(group.color)}"></p-tag>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
    <div *ngIf="authGuard.hasPermission('PERMISSION_VIEW_ALARMS')" class="col-12">
      <div class="col-12 form-field">
        <label for="alarm">{{'misc.alarm' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.alarmsDefinitionUuids" [placeholder]="'select.generic' | transloco"
                       [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="alarms" id="alarm"
                       optionLabel="name" optionValue="alarmDefinitionUuid"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <p-button [label]="'common.filter' | transloco" [disabled]="!(
            currentFilters.alias ||
            currentFilters.serialNumber ||
            currentFilters.eui ||
            currentFilters.simNumber ||
            currentFilters.isPoweredOn != null ||
            currentFilters.isOn != null ||
            organizations ||
            currentFilters.machineModelUuids ||
            currentFilters.countries ||
            currentFilters.states ||
            currentFilters.localities ||
            currentFilters.communicationType ||
            rangeDates ||
            (currentFilters.from &&
            currentFilters.until) ||
            currentFilters.deleted != null ||
            currentFilters.machineGroupsUuids ||
            currentFilters.alarmsDefinitionUuids
          )" (onClick)="filtersVisible = false; applyFilters()" styleClass="p-button-primary mx-2 mt-2" type="button">
      </p-button>
      <p-button [label]="'common.clear' | transloco" (click)="resetFilters(); filtersVisible = false; applyFilters()"
                styleClass="p-button-danger" type="button"></p-button>
    </div>
  </div>
</p-sidebar>

<app-export-xls *ngIf="exportVisible"
                [content]="machines"
                [machineFilters]="currentFilters"
                [typeContent]="'MACHINE'"
                [exportFileType]="ExportFileType.MACHINES_LIST"
                [typeExport]="'XLSX'"
                [(visible)]="exportVisible">
</app-export-xls>
